if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['selected-index'];
    }

    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index')) || 0;
    }

    set selectedIndex(index) {
      this.setAttribute('selected-index', `${index}`);
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.autoplay = true;
      this.autoplayDelay = this.dataset.autoplay ? parseInt(this.dataset.autoplay) : 0;
      this.reachEndDelay = Math.max(500, this.autoplayDelay);
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      
      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
        spaceBetween: columnGap.tablet,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.tabletLarge
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop
          },
        },
        loop: true,
        threshold: 2,
        on: {
          init: this.handleSliderInit.bind(this),
        }
      };

      if (typeof this.sliderInstance !== 'object') {

        console.log(sliderOptions);
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        // this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [
        //   FoxTheme.Swiper.Autoplay,
        //   FoxTheme.Swiper.EffectFade,
        // ]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    handleSliderInit() {
      // Fix active bullet not transition on the first time.
      if (this.sliderPagination) {
        const activeBullet = this.sliderPagination.querySelector('.swiper-pagination-bullet-active');

        if (activeBullet) {
          activeBullet.classList.remove('swiper-pagination-bullet-active');
          activeBullet.offsetHeight; // Trigger reflow.
          activeBullet.classList.add('swiper-pagination-bullet-active');
        }
      }
    }

    onMouseOver(event) {
      const target = event.currentTarget;
      const index = Number(target.dataset.index);

      clearTimeout(this.hoverTracker);
      this.hoverTracker = setTimeout(() => {
        this.selectedIndex = index;
      }, 100);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'selected-index' && oldValue !== newValue) {
        // Set status for headings.
        Array.from(this.textHovering).forEach((icon) => {
          if (icon.dataset.index != newValue) {
            icon.classList.remove('is-active');
          } else {
            icon.classList.add('is-active');
          }
        });

        // Update active collection medias.
        const slides = this.sliderWrapper.querySelectorAll('[data-filter]');
        Array.from(slides).forEach((slide) => {
          if (slide.dataset.filter == newValue) {
            slide.classList.remove('!hidden');
            slide.classList.add('swiper-slide');

            const motionEls = slide.querySelectorAll('motion-element');
            motionEls &&
              motionEls.forEach((motionEl) => {
                motionEl.refreshAnimation();
              });
          } else {
            slide.classList.add('!hidden');
            slide.classList.remove('swiper-slide');
          }
        });
        this.pause();
        this.sliderInstance.slider.destroy();
        this.initSlider();
        this.play();

        if (oldValue !== null) {
          Array.from(this.collectionsInfo).forEach((item) => {
            if (item.dataset.filter == oldValue) {
              item.classList.add('!hidden');
              const motionEls = item.querySelectorAll('motion-element');
              motionEls &&
                motionEls.forEach((motionEl) => {
                  motionEl.resetAnimation();
                });
            }
          });
        }

        Array.from(this.collectionsInfo).forEach((item) => {
          if (item.dataset.filter == newValue) {
            item.classList.remove('!hidden');

            const colorScheme = item.dataset.colorScheme;
            this.updateControlsScheme(colorScheme);

            const motionEls = item.querySelectorAll('motion-element');
            motionEls.forEach((motionEl) => {
              motionEl.refreshAnimation();
            });
          }
        });
      }
    }

    activeNextItem() {
      if (this.textHovering[this.selectedIndex + 1]) {
        this.selectedIndex++;
      } else {
        this.selectedIndex = 0;
      }
    }

    updateControlsScheme(newColorScheme) {
      const classesToRemove = Array.from(this.collectionMedia.classList).filter((className) =>
        className.startsWith('color-')
      );
      classesToRemove.forEach((className) => this.collectionMedia.classList.remove(className));
      this.collectionMedia.classList.add(newColorScheme);
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('collection-list', CollectionList);
}
